/** @format */
export const SET_SERVICE_INITIATION_POPULATE_PAYLOAD_SUCCESS = 'SET_SERVICE_INITIATION_POPULATE_PAYLOAD_SUCCESS';
export const SET_SERVICE_INITIATION_PARAMS_SUCCESS = 'SET_SERVICE_INITIATION_PARAMS_SUCCESS';
export const GET_SERVICE_INITIATION_FILTERS_SUCCESS = 'GET_SERVICE_INITIATION_FILTERS_SUCCESS';

// Fetch service initiation requests
export const GET_SERVICE_INITIATION_REQUESTS_PENDING = 'GET_SERVICE_INITIATION_REQUESTS_PENDING';
export const GET_SERVICE_INITIATION_REQUESTS_SUCCESS = 'GET_SERVICE_INITIATION_REQUESTS_SUCCESS';
export const GET_SERVICE_INITIATION_REQUESTS_FAILURE = 'GET_SERVICE_INITIATION_REQUESTS_FAILURE';

// Fetch service initiation detail
export const GET_SERVICE_INITIATION_DETAIL_PENDING = 'GET_SERVICE_INITIATION_DETAIL_PENDING';
export const GET_SERVICE_INITIATION_DETAIL_SUCCESS = 'GET_SERVICE_INITIATION_DETAIL_SUCCESS';
export const GET_SERVICE_INITIATION_DETAIL_FAILURE = 'GET_SERVICE_INITIATION_DETAIL_FAILURE';

// Update EY Action
export const UPDATE_SERVICE_INITIATION_ACTION_PENDING = 'UPDATE_SERVICE_INITIATION_ACTION_PENDING';
export const UPDATE_SERVICE_INITIATION_ACTION_SUCCESS = 'UPDATE_SERVICE_INITIATION_ACTION_SUCCESS';
export const UPDATE_SERVICE_INITIATION_ACTION_FAILURE = 'UPDATE_SERVICE_INITIATION_ACTION_FAILURE';

// Reset selected service request
export const RESET_SERVICE_INITIATION_DETAIL = 'RESET_SERVICE_INITIATION_DETAIL';

// Set filters
export const SET_SERVICE_INITIATION_FILTERS = 'SET_SERVICE_INITIATION_FILTERS';

export const ON_CHANGE_SERVICE_INITIATION_FILTER = 'ON_CHANGE_SERVICE_INITIATION_FILTER';

// Clear filters
export const CLEAR_SERVICE_INITIATION_FILTERS = 'CLEAR_SERVICE_INITIATION_FILTERS';
